module.exports = __webpack_public_path__ + "media/old_images/image-promo-landing-05-725eeae4.jpg";